module.exports = __webpack_public_path__ + "img/bab0t4.bbc17148.png";